import DocumentosConfigEnvelopeSelecionados from "../../DocumentosConfigEnvelope/DocumentosConfigEnvelopeSelecionados";

interface ITabelaDeConfigEnvelopeDadosProps {}

export default function TabelaDeConfigEnvelopeDados(
    props: ITabelaDeConfigEnvelopeDadosProps
) {
    return <DocumentosConfigEnvelopeSelecionados mostrarRubricas />;
}
